import { render, staticRenderFns } from "./download_home.vue?vue&type=template&id=476dab8a&scoped=true"
import script from "./download_home.vue?vue&type=script&lang=js"
export * from "./download_home.vue?vue&type=script&lang=js"
import style0 from "./download_home.vue?vue&type=style&index=0&id=476dab8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476dab8a",
  null
  
)

export default component.exports